export const OBJFileLoaderMetadata = {
    name: "obj",
    // Read the file as bytes so the loader can decode non-UTF-8 OBJ files.
    extensions: {
        ".obj": { isBinary: true },
    },
};
//# sourceMappingURL=objFileLoader.metadata.js.map